import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

function AdminRoute({ element }) {
  const { token, loading: authLoading } = useSelector(
    (state) => state.authSlice
  );
  const { admin, user, error, loading: profileLoading } = useSelector(
    (state) => state.profileSlice
  );

  if (authLoading) {
    return null;
  }

  if (!token) {
    return <Navigate to="/welcome" />;
  }

  // Wait for the profile (which carries the admin flag) before deciding, so a
  // hard refresh straight to this route doesn't bounce an admin to home before
  // getProfile has resolved.
  if (profileLoading || (!user && !error)) {
    return null;
  }

  return admin ? element : <Navigate to="/" />;
}

export default AdminRoute;
